export default [
  {
    name: 'site-videos',
    path: '/settings/site/videos',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Vídeos',
      icon: 'dvr',
      label: 'Vídeos',
      roles: []
    }
  },
  {
    name: 'site-video-edit',
    path: '/settings/site/videos/:id/edit',
    component: () => import(/* webpackChunkName: "event" */ './Form.vue'),
    meta: {
      showNavbar: false,
      title: 'Vídeo - Edição',
      icon: 'dvr',
      label: 'Vídeo - Edição',
      roles: []
    }
  },
  {
    name: 'site-video-new',
    path: '/settings/site/videos/novo',
    component: () => import(/* webpackChunkName: "event" */ './Form.vue'),
    meta: {
      showNavbar: false,
      title: 'Vídeo - Adicionar',
      icon: 'dvr',
      label: 'Vídeo - Adicionar',
      roles: []
    }
  }
]
